import { Injectable } from '@angular/core';
import { FormfieldDefaultOptions } from '@allianz/ng-aquila/formfield';
import { ErrorDefaultOptions } from '@allianz/ng-aquila/base';
import { Role } from '@ps20/bff-models';

@Injectable({
  providedIn: 'root',
})
export class DesignOptionenService {
  expertStylesConfiguration = {
    formfieldOptions: {
      appearance: 'outline',
      nxFloatLabel: 'always',
    } as FormfieldDefaultOptions,
    errorOptions: {
      appearance: null,
    } as ErrorDefaultOptions,
  };

  private readonly _designOptions = {
    [Role.VERTRETER]: this.expertStylesConfiguration,
    [Role.SPS]: this.expertStylesConfiguration,
    [Role.MAKLERBETREUER]: this.expertStylesConfiguration,
    [Role.MAKLER]: this.expertStylesConfiguration,
    [Role.UVM]: this.expertStylesConfiguration,
    [Role.LEITENDER_KUNDENBETREUER]: this.expertStylesConfiguration,
    [Role.NEBENBERUFSVERTRETER]: this.expertStylesConfiguration,
    [Role.UNDERWRITER_UNFALL]: this.expertStylesConfiguration,
    [Role.UWPSHRK]: this.expertStylesConfiguration,
    [Role.OLB]: this.expertStylesConfiguration,
    [Role.GENO]: this.expertStylesConfiguration,
    [Role.AGENTURANGESTELLTER]: this.expertStylesConfiguration,
    [Role.VTTEL]: this.expertStylesConfiguration,
    [Role.VTGEV]: this.expertStylesConfiguration,
    [Role.VTKUS]: this.expertStylesConfiguration,
    [Role.VTKVM]: this.expertStylesConfiguration,
    [Role.GER_SDW_UW_USER]: this.expertStylesConfiguration,
    [Role.ENDKUNDE]: {
      formfieldOptions: {
        appearance: 'auto',
        nxFloatLabel: 'auto',
      } as FormfieldDefaultOptions,
      errorOptions: {
        appearance: null,
      } as ErrorDefaultOptions,
    },
  };
  private _currentDesign = this._designOptions[Role.VERTRETER];

  getCurrentDesignOptions(): {
    formfieldOptions: FormfieldDefaultOptions;
    errorOptions: ErrorDefaultOptions;
  } {
    return this._currentDesign;
  }

  setCurrentDesignOptions(role: Role): void {
    this._currentDesign = this._designOptions[role as keyof typeof this._designOptions];
  }
}
